module.exports = __webpack_public_path__ + "static/media/instructor-1.40b7ffb3.png";